import {Component} from '@angular/core';
import {DcpSupportFormService} from '../../../shared/support-form/dcp-support-form.service';
import {HttpStatusCode} from '@angular/common/http';

@Component({
  selector: 'dcp-order-history-processing-error',
  templateUrl: './order-history-processing-error.component.html',
})
export class OrderHistoryProcessingErrorComponent {

  constructor(private dcpSupportFormService: DcpSupportFormService) {
  }

  openSupportForm() {
    this.dcpSupportFormService.open('ValidateCanPlaceOrder', HttpStatusCode.Conflict + '');
  }
}
